import { Injectable } from '@angular/core';
import { HttpService, VersionedData } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { ModifierDto } from '../dtos';

@Injectable()
export class ModifiersService {
  private path = 'versionedupdate/modifiers';
  constructor(private httpService: HttpService) {}

  public getModifiers(versionHash: string): Observable<VersionedData<ModifierDto[]>> {
    return this.httpService.makeGet(`${this.path}/${versionHash}`);
  }
}
